import React from "react";
import { Utils } from "../../../common/views/Utils";
import { PrintInvoiceLabelModel, PaymentRequirement, PackageType } from "../../models/InvoiceModel";

interface InvoiceLabelFooterProps {
    exchangeRate: number;
    invoice: PrintInvoiceLabelModel;
}

export default function InvoiceLabelFooterView({ exchangeRate, invoice }: InvoiceLabelFooterProps) {
    const col1Class = Utils.getColumnWidth(6);
    const col2Class = Utils.getColumnWidth(6);

    return <div>
        <div className="ms-Grid-row">
            <div className={col1Class + " center"}>
                Pay: {Utils.splitCapitalCase(PaymentRequirement[invoice.paymentRequirement])}
            </div>
            <div className={col2Class + " center"}>{Utils.formatShortDate(invoice.date)}</div>
        </div>

        <div className="ms-Grid-row pt-5">
            <div className={col1Class + " center"}>
                KH {Utils.formatNumber(invoice.balance * exchangeRate)}
            </div>
            <div className={col2Class + " center"}>
                {Utils.splitCapitalCase(PackageType[invoice.packageType])}
            </div>
        </div>

        <div className="ms-Grid-row label2-brand-font">
            <div className={col1Class + " center"}>
                $ {Utils.formatNumber(invoice.balance)}
            </div>
            <div className={col2Class + " center"}>{invoice.deliveryMethod}</div>
        </div>
    </div>;
}